var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "bg-light" }, [
    _c("div", { staticClass: "row", class: { "no-gutters": _vm.$mq.phone } }, [
      _c("div", { staticClass: "col-12 col-lg-6 offset-lg-3" }, [
        _c("div", { staticClass: "row pt-3" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "card shadow-sm" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.rewards.your_points")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-start align-items-center mt-2"
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "ml-4" }, [
                        _c("h1", { staticClass: "d-inline-block mb-0" }, [
                          _vm._v(
                            _vm._s(_vm._f("prettyNumber")(_vm.totalPoints))
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-secondary" }, [
                          _vm._v(_vm._s(_vm.$t("message.rewards.points")))
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.userPointGroups && _vm.userPointGroups.length
                    ? _c(
                        "div",
                        { staticClass: "mt-2 text-remark text-secondary" },
                        _vm._l(_vm.userPointGroups, function(userPointGroup) {
                          return _c("div", [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("prettyNumber")(userPointGroup.points)
                                ) +
                                  " " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.rewards.points_will_expire_date"
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm._f("prettyOnlyDate")(
                                      userPointGroup.expire_date
                                    )
                                  )
                              )
                            ])
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-start align-items-center"
                    },
                    [
                      _c("div", { staticClass: "flex-grow-1" }, [
                        _c("b", [
                          _vm._v(_vm._s(_vm.$t("message.rewards.how_it_works")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "a",
                          {
                            staticClass: "text-dark",
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.visible = !_vm.visible
                              }
                            }
                          },
                          [
                            _vm.visible === false
                              ? _c("i", { staticClass: "fas fa-angle-down" })
                              : _c("i", { staticClass: "fas fa-angle-up" })
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.rewardInfo
                    ? _c(
                        "b-collapse",
                        {
                          staticClass: "mt-2",
                          attrs: { id: "collapse-1" },
                          model: {
                            value: _vm.visible,
                            callback: function($$v) {
                              _vm.visible = $$v
                            },
                            expression: "visible"
                          }
                        },
                        [
                          _vm.$i18n.locale === "th"
                            ? _c("div", {
                                staticClass: "text-small",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.rewardInfo.earning_point_conditions
                                      .detail_th
                                  )
                                }
                              })
                            : _c("div", {
                                staticClass: "text-small",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.rewardInfo.earning_point_conditions
                                      .detail_en
                                  )
                                }
                              })
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "router-link",
                { staticClass: "text-info", attrs: { to: "/user-rewards" } },
                [
                  _c("div", { staticClass: "card shadow-sm" }, [
                    _c("div", { staticClass: "card-body text-center" }, [
                      _c("i", { staticClass: "fas fa-gift fa-lg" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "pt-3 text-dark" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.rewards.my_redeemed_rewards")
                            )
                          )
                        ])
                      ])
                    ])
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "router-link",
                { staticClass: "text-info", attrs: { to: "/user-points" } },
                [
                  _c("div", { staticClass: "card shadow-sm" }, [
                    _c("div", { staticClass: "card-body text-center" }, [
                      _c("i", { staticClass: "fas fa-clock fa-lg" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "pt-3 text-dark" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$t("message.rewards.points_history"))
                          )
                        ])
                      ])
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.rewards
      ? _c("div", { staticClass: "container pt-3" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c(
                "div",
                { staticClass: "col-12", class: { "p-0": _vm.$mq.phone } },
                [
                  _c("h3", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(_vm.$t("message.rewards.list")))
                  ])
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.rewards, function(reward, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "col-lg-6 col-12",
                    class: { "p-0": _vm.$mq.phone }
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "no-style",
                        attrs: { to: "/rewards/" + reward.id }
                      },
                      [
                        _c("div", { staticClass: "card shadow-sm" }, [
                          _c("div", { staticClass: "card-body p-3" }, [
                            _c("div", { staticClass: "d-flex flex-row" }, [
                              _c("div", { staticClass: "w-50" }, [
                                _c("img", {
                                  staticClass: "img-fluid rounded",
                                  attrs: { src: reward.image_url, alt: "" }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "w-50 pl-3 pt-2" }, [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    _c("h3", { staticClass: "mb-2" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$i18n.locale === "th"
                                            ? reward.title_th
                                            : reward.title_en
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text-secondary text-small"
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.rewards.redeem_by"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "h4",
                                          { staticClass: "d-inline-block" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("prettyOnlyDate")(
                                                  reward.end_date
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "mt-4 text-right" },
                                      [
                                        _c(
                                          "h4",
                                          {
                                            staticClass:
                                              "d-inline-block text-info"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("prettyNumber")(
                                                  reward.points
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-secondary text-small"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("message.rewards.points")
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("i", { staticClass: "fas fa-trophy-alt -status-pending fa-2x" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f525f63c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f525f63c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reward/Index.vue
// module id = 2294
// module chunks = 0